export const IP = "https://api.geatakamol.com";

// export const IP = "http://localhost:8000";
